import { Alert, AlertDescription, AlertTitle } from '@/shared/components/ui/alert';
import { Button } from '@/shared/components/ui/button';
import { useRouteErrorRetry } from '@/shared/hooks/useRouteErrorRetry';
import { routeErrorDescriptor } from '@/shared/lib/routeErrorMessage';
import { Trans, useLingui } from '@lingui/react/macro';
import { type ErrorComponentProps, useCanGoBack, useRouter } from '@tanstack/react-router';
import { AlertTriangle, ArrowLeft } from 'lucide-react';

export function SystemRouteErrorState({ error }: ErrorComponentProps) {
  const { i18n } = useLingui();
  const router = useRouter();
  const canGoBack = useCanGoBack();
  const retry = useRouteErrorRetry();

  return (
    <div className="flex min-h-svh flex-1 items-center justify-center bg-background p-6">
      <Alert variant="destructive" className="relative max-w-md pb-14">
        <AlertTriangle />
        <AlertTitle>
          <Trans>Could not load this page</Trans>
        </AlertTitle>
        <AlertDescription>{i18n._(routeErrorDescriptor(error))}</AlertDescription>

        {canGoBack ? (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="absolute bottom-3 left-3 text-foreground"
            onClick={() => router.history.back()}
          >
            <ArrowLeft />
            <Trans>Go back</Trans>
          </Button>
        ) : null}

        <Button
          type="button"
          variant="outline"
          size="sm"
          className="absolute right-3 bottom-3 text-foreground"
          onClick={retry}
        >
          <Trans>Try again</Trans>
        </Button>
      </Alert>
    </div>
  );
}
